import { render } from "./index.html?vue&type=template&id=f3b8d298&ts=true&external"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"

import "./index.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__